export const copyPasteTemplatesContent = `# Copy-Paste Templates

## Minimal \`App.tsx\`

\`\`\`tsx
import { LightswitchProvider, ProtectedRoute } from "lightswitch-js";
import { useLightswitchAuth } from "lightswitch-js";
import { supabase } from "@/integrations/supabase/client";

function Landing() {
  const { handleLightswitchSignIn, handleLightswitchSignUp } = useLightswitchAuth();
  return (
    <div>
      <h1>Welcome</h1>
      <button onClick={() => handleLightswitchSignIn("/app")}>Sign In</button>
      <button onClick={() => handleLightswitchSignUp("/app")}>Start Your Flow</button>
    </div>
  );
}

function AppArea() {
  return (
    <ProtectedRoute>
      <h2>Paid Dashboard</h2>
    </ProtectedRoute>
  );
}

export default function App() {
  return (
    <LightswitchProvider
      publishableKey="pk_flow-state-app"
      appSlug="flow-state-app"
      supabaseClient={supabase}
      autoShowPaywall={true}
    >
      {/* router with / (Landing) and /app (AppArea) */}
    </LightswitchProvider>
  );
}
\`\`\`

## \`package.json\`

\`\`\`json
{
  "dependencies": {
    "lightswitch-js": "^0.0.6"
  }
}
\`\`\``;
